import dayjs from "dayjs";

import { JobStatusEnum } from "@/types/job";

export const jobStatusValues: Record<string, JobStatusEnum> = {
  Draft: "Draft",
  Active: "Active",
  Underscreening: "Underscreening",
  Closed: "Closed",
  Rejected: "Rejected",
  Hold: "Hold",
};

export const jobStatusOption: {
  value: JobStatusEnum;
  label: string;
}[] = [
  { value: jobStatusValues.Draft, label: "Draft" },
  { value: jobStatusValues.Active, label: "Active" },
  // { value: jobStatusValues.Underscreening, label: "Underscreening" },
  { value: jobStatusValues.Closed, label: "Close" },
  { value: jobStatusValues.Hold, label: "On-Hold" },
  // { value: jobStatusValues.Rejected, label: "Reject" },
];

export const intervalOptions = [
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
];

export const defaultDateRange = {
  from: dayjs().subtract(30, "day").toDate(),
  to: dayjs().toDate(),
};

export const DEFAULT_OPEN_ACCORDIONS = [
  "overall-stats",
  "screening-stages",
  "z-interview-stages",
  "post-submission-stages",
  "reject-drop-stats",
  "reject-reason",
  "interviewer-performance",
];

export const COLORS = [
  "#6366F1", // indigo
  "#3B82F6", // blue
  "#0EA5E9", // sky
  "#22C55E", // green
  "#14B8A6", // teal
  "#EAB308", // yellow
  "#F97316", // orange
  "#EF4444", // red
  "#EC4899", // pink
  "#A855F7", // purple
  "#8B5CF6", // violet
  "#64748B", // slate
];
